import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  
  <React.StrictMode>
    
    <App />
  </React.StrictMode>
);

// Service Worker отключён: устаревший SW кэшировал старую версию приложения и не обновлялся
// (service-worker.js больше не генерируется билдом → старый SW «застревал» у пользователей,
// они видели старый воркфлоу несмотря на деплой). unregister() снимает активные SW, плюс
// чистим Cache Storage — чтобы всегда грузилась свежая версия с сервера.
serviceWorkerRegistration.unregister();
if ('caches' in window) {
  caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
}

// Опционально, для логирования производительности
reportWebVitals();
